// src/Pages/Landing/DjPaijatHameLanding.jsx
import React, { useMemo } from "react";
import NeonButton from "../../components/ResponsiveButton/NeonButton.jsx";
import { trackLandingCta } from "../../utils/analytics";

/**
 * DJ Päijät-Hämeessä -landing React Shelliin.
 * Metat/JSON-LD tulevat WordPressistä.
 * Tavoite: selkeä CTA DJ-hakuun Päijät-Hämeessä, ei hintalaatikkoa vielä.
 */

export default function DjPaijatHameLanding() {
  // Paikallisen päivän ISO (YYYY-MM-DD)
  const today = useMemo(() => {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
  }, []);

  return (
    <section className="relative max-w-6xl mx-auto px-4 pt-24 pb-24">
      {/* Hero / ingressi */}
      <header className="rounded-2xl overflow-hidden ring-1 ring-black/10 dark:ring-white/10 bg-white/70 dark:bg-black/50 backdrop-blur-md p-8 md:p-12 shadow-lg">
        <h1 className="text-4xl md:text-6xl font-bold leading-tight text-black dark:text-white">
          DJ Päijät-Hämeessä – vapaat DJ:t juhliin
        </h1>

        <p className="mt-4 text-black/80 dark:text-white/80 text-base md:text-lg max-w-3xl">
          Buukkerista löydät Päijät-Hämeen vapaat DJ:t reaaliaikaisesti.{" "}
          <strong>
            Valitse päivämäärä, katso vapaat DJ:t ja pyydä tarjous parilla
            klikkauksella.
          </strong>
        </p>

        <p className="mt-3 text-black/80 dark:text-white/80 text-base md:text-lg max-w-3xl">
        Tarjottu hinta on aina{" "}
        <strong>kokonaishinta (sisältää myös matkakulut)</strong>.
        Esiintyjän tarjoamat lisäpalvelut näkyvät hänen profiilissaan ja
        buukkauksen jälkeen niistä voi sopia tarkemmin suoraan esiintyjän kanssa.
        </p>

        {/* CTA-napit */}
        <div className="mt-6 flex flex-col sm:flex-row gap-3">
          <a
            href={`/?type=dj&maakunta=paijat-hame&date=${today}&clear=1#tulokset`}
            aria-label="Näytä tämän päivän vapaat DJ:t (Päijät-Häme)"
            onClick={() =>
              trackLandingCta({
                actType: "dj",
                region: "paijat-hame",
                placement: "hero_primary_today",
              })
            }
          >
            <NeonButton variant="primary" size="md" className="font-semibold">
              Näytä tämän päivän vapaat DJ:t (Päijät-Häme)
            </NeonButton>
          </a>

          <a
            href={`/?type=dj&book=1&maakunta=paijat-hame&clear=1#tulokset`}
            aria-label="Avaa pikahaku DJ:lle"
            onClick={() =>
              trackLandingCta({
                actType: "dj",
                region: "paijat-hame",
                placement: "hero_quick_search",
              })
            }
          >
            <NeonButton variant="secondary" size="md" className="font-semibold">
              Avaa pikahaku 
            </NeonButton>
          </a>
        </div>
      </header>

      {/* Ristiinlinkitys */}
      <div className="mt-8 rounded-2xl p-6 md:p-8 bg-white/70 dark:bg-zinc-900/60 ring-1 ring-black/10 dark:ring-white/10 shadow-lg">
        <p className="text-black/80 dark:text-white/80 text-base md:text-lg">
          Tarvitsetko bilebändiä tai trubaduuria Päijät-Hämeessä? Siirry{" "}
          <a className="underline" href="/bilebandi-paijat-hame/">
            Bilebändi Päijät-Häme
          </a>{" "}
          tai{" "}
          <a className="underline" href="/trubaduuri-paijat-hame/">
            Trubaduuri Päijät-Häme
          </a>
          {" "}
          -sivulle. Lue myös:{" "}
          <a
            className="underline"
            href="https://buukkeri.fi/blogi/nain-loydat-taydellisen-esiintyjan-juhliisi"
          >
            Näin löydät täydellisen esiintyjän juhliisi
          </a>
          .
        </p>
      </div>
    </section>
  );
}
